export enum KeyboardKeys {
  ESCAPE = "Escape",
  ESCAPE_SHORT = 'Esc',
  TAB = "Tab",
  ENTER = "Enter",
  SPACE = " ",
  SHIFT = "Shift",
  ARROW_LEFT = "ArrowLeft",
  ARROW_RIGHT = "ArrowRight",
  ARROW_UP = "ArrowUp",
  ARROW_DOWN = "ArrowDown"
}

interface KeyboardKeyCacheMapValuesModel {
  isTabKey: boolean;
  isEscKey: boolean;
  isEnterKey: boolean;
  isSpaceKey: boolean;
  isShiftKey: boolean;
  isArrowLeftKey: boolean;
  isArrowRightKey: boolean;
  isArrowUpKey: boolean;
  isArrowDownKey: boolean;
}

export type KeyboardKeyCacheMapModel = Map<string, KeyboardKeyCacheMapValuesModel>;

export const keyboardKeyCacheMapDefaultValues: Readonly<KeyboardKeyCacheMapValuesModel> = {
  isTabKey: false,
  isEscKey: false,
  isEnterKey: false,
  isSpaceKey: false,
  isShiftKey: false,
  isArrowLeftKey: false,
  isArrowRightKey: false,
  isArrowUpKey: false,
  isArrowDownKey: false
};
